import React, { Component } from 'react';
import { addUser } from '../service/userwsao'
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReactGA from 'react-ga';
import YouTube from 'react-youtube';
// import uploaderImg from 'assets/img/team/annapandarina.jpg'
import uploaderImg from 'assets/img/featured/jasper-menken.jpg'
import img1 from 'assets/img/team/1.jpg'
import img2 from 'assets/img/team/zino.jpg'
import img3 from 'assets/img/team/3.jpg'
import img4 from 'assets/img/patrons/bsmick97.jpg'
import FadeIn from 'react-fade-in';
import 'assets/css/elisyam-1.5.css';
import Typist from 'react-typist';
import SoundEngine from '../../../engines/SoundEngine';
import { downloadDemoSynth } from '../service/synthwsao';


ReactGA.initialize('UA-115012851-1');
ReactGA.pageview(window.location.pathname + window.location.search);

class Header extends Component {

    // initialize form
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            email: '',
            gdprOptIn: false,
            submitted: false,
            player: {},
            showRecipe: false
        };

        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    // handle change of form values bound to state
    handleChange(event) {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            [name]: value
        });
    }

    // call ws when submitted
    handleSubmit(event) {

        if (!this.state.name) {
            toast.error("You forgot to your name");
            return;
        }

        if (!this.state.email) {
            toast.error("You forgot your email");
            return;
        }

        // validate user opt in button
        if (!this.state.gdprOptIn) {
            toast.error(
                <div>
                    <h3 style={{ color: 'white' }}>GDPR Sucks!</h3> <p>Please sign up for updates to receive the newsletter! You will never be spammed <span role="img" aria-label="smiley face">🙂</span>.</p>
                </div>, { autoClose: 10000 });
            return;
        }

        addUser(this.state, () => {
            // disable submit button
            this.setState({
                submitted: true
            });

            ReactGA.event({
                category: 'conversion',
                action: 'Signed Up to synthCity Alpha',
                label: 'synthCity Alpha Button',
                value: 1
            });

            // show welcome message
            toast.success(<div style={{ fontFamily: 'Poppins', "textAlign": 'center' }}>Your personal invitation link has been sent to <strong>{this.state.email}</strong>!</div>,
                {
                    autoClose: 20 * 1000,
                    position: "top-center",
                });

        }, (status) => {

            // user is duplicate
            if (status === 409) {
                toast.error(<div style={{ fontFamily: 'Poppins', "textAlign": 'center' }}>This email is already signed up! <strong>Check your inbox or spam folder!</strong></div>,
                    {
                        autoClose: 20 * 1000,
                        position: "top-center",
                    });
            } else {
                toast.error('An error occurred while signing you up :\'(');
                toast.error("Tweet me @deztructicus and I'll fix it! ^__^");
            }
        });


        event.preventDefault();
    }

    _onReady(e) {
        this.setState({ player: e.target });
    }

    render() {

        let start = 15;
        let end = 26;

        let Recipe = () => {
            return <FadeIn><div className="db-social">
                <div className="widget has-shadow">
                    {/* Begin Widget Header */}
                    <div className="widget-header d-flex align-items-center">
                        <div className="user-image">
                            <img className="rounded-circle" src={uploaderImg} alt="..." />
                        </div>
                        <div className="d-flex flex-column mr-auto">
                            <div className="title">
                                <span className="username">Goodbye To A World ~ Serum Preset</span>
                            </div>
                            {/* <div className="time">By AnnaPandarina</div> */}
                            <div className="time">By Deepseastronaut</div>
                            <div className="time">a month ago</div>
                        </div>
                    </div>
                    {/* End Widget Header */}
                    {/* Begin Widget Body */}
                    <div className="widget-body">
                        <p>
                            A Sine Oscillator and a Noise Oscillator should do it!.

                            First, Filter them both at about 740hz.
                            Next modulate the level for the Sine Oscillator using an Envelope with a sharp  0.5ms Attack and about 800ms Decay to give that nice plucky base sound.
                            Next modulate the level for the Noise Oscillator using an Envelope of about 320ms Attack, 4.5s Decay and 2s Release.

                            And voila! Recreate-able on any synth!<br /><br />

                            Download the synth preset below! ^___^

                        </p>
                    </div>
                    {/* End Widget Body */}
                    {/* Begin Widget Footer */}
                    <div className="widget-footer d-flex align-items-center">
                        <div className="col-xl-8 col-md-8 col-7 no-padding d-flex justify-content-start">
                            <div className="users-like">
                                <a href="https://app.synthcity.io/citizen/kanbaru">
                                    <img src={img1} className="img-fluid rounded-circle" alt="..." />
                                </a>
                                <a href="https://app.synthcity.io/citizen/PRYZM">
                                    <img src={img2} className="img-fluid rounded-circle" alt="..." />
                                </a>
                                <a href="https://app.synthcity.io/citizen/MEMSUS">
                                    <img src={img3} className="img-fluid rounded-circle" alt="..." />
                                </a>
                                <a href="https://app.synthcity.io/citizen/Deepseastronaut">
                                    <img src={img4} className="img-fluid rounded-circle" alt="..." />
                                </a>
                                <a className="view-more" href="https://app.synthcity.io/citizen/Zeeno">
                                    +4
                                </a>
                            </div>
                        </div>
                        <div className="col-xl-4 col-md-4 col-5 no-padding d-flex justify-content-end">
                            <div className="meta">
                                <ul>
                                    <li>
                                        <button className="sxybtn" onClick={() => {

                                            downloadDemoSynth().then().catch();
                                        }}>
                                            <i className="la la-download" /><span className="numb">download</span>
                                        </button>
                                    </li>
                                    <li>
                                        <button className="sxybtn" onClick={() => {
                                            SoundEngine.play('https://mazino-media-assets.s3.eu-west-2.amazonaws.com/pluck_goodbye_to_a_world.mp3')
                                        }}>
                                            <i className="la la-play-circle" /><span className="numb">preview</span>
                                        </button>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                    {/* End Widget Footer */}
                </div>
            </div>
            </FadeIn>
        }

        let rightSide = <div className="col-lg-12 widget" style={{ borderRadius: "4px" }}>
            <div className="row">

                <div className="col-lg-10" style={{ padding: "15px", fontSize: '1.3em' }}>
                    <Typist>
                        How do I recreate the <span className="important-text">pluck synth</span> in <span style={{ color: "orange", fontWeight: "600" }}>Goodbye To A World</span>? 🤔
                    </Typist>
                </div>

                <div className="col-lg-2" style={{ padding: "15px", fontSize: '1.3em' }}>
                    <button className="btn btn-primary" onClick={() => {
                        this.setState({ showRecipe: true });

                        ReactGA.event({
                            category: 'engagement',
                            action: 'Interacted with eye catcher',
                            label: 'eye_catcher',
                            value: 1
                        });
                    }}>Search</button>
                </div>
            </div>
        </div>

        if (this.state.showRecipe) {

            rightSide = <Recipe />;
        }
        return (
            <div>
                <section id="header-sign-up">
                    <header id="intro-hero" className="fullscreen dark-overlay" style={{ background: 'url(assets/img/intro-bg.jpg) no-repeat', backgroundSize: 'cover' }}>
                        <div className="container-fluid">
                            <div className="row">
                                <div className="col-12 text-center hero-content text-white">
                                    <h1 className="hero-title">Join The Community <br /> That's Revolutionizing Synthesizers</h1>


                                    {/* <p>Learn ~ Practice ~ Share</p> */}
                                    <p className="hero-tagline">
                                        synthCity is an educational social network for sound designers. Check it out now!
                                    </p>
                                    {/* Begin Solution */}
                                    <div className="container-fluid" style={{
                                        paddingTop: "20px"
                                    }}>
                                        <div className="row justify-content-center">
                                            <div className="col-xl-11">
                                                <div className="row ">

                                                    {/* Begin video */}
                                                    <div className="col-xl-6 column">
                                                        <div className="embed-responsive embed-responsive-16by9 ">
                                                            <YouTube
                                                                videoId="W2TE0DjdNqI"
                                                                onReady={this._onReady.bind(this)}
                                                                opts={{
                                                                    playerVars: {
                                                                        autoplay: 0,
                                                                        origin: "synthcity.io",
                                                                        start,
                                                                        end,
                                                                        loop: true
                                                                    }
                                                                }}
                                                                onStateChange={(e) => {
                                                                    // if reached end, immediately loop to start
                                                                    if (e.data === 0) {
                                                                        this.state.player.seekTo(start);
                                                                    }
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                    {/* end video */}
                                                    <div className="col-xl-6 column">

                                                        <div className="intro-btn mt-5">
                                                        </div>


                                                        {/* Begin Recipe */}

                                                        {rightSide}
                                                        {/* End Recipe */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {/* End Solution */}
                                </div>
                                {/* END col-12*/}

                                {/* END col-12*/}
                            </div> {/* END row*/}
                        </div> {/* END container*/}
                    </header> {/* END header*/}
                </section>
            </div>
        );
    }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/synthcity/landing/Header.js